export const esCO = {
    "#FilteredItemsOf#": "# Elementos filtrados de #",
    "#MinutesAgo": "Hace # minutos",
    "aBranchWithTheName#branchName#AlreadyExists": "Ya existe una sucural con el nombre #nombrede la sucursal#",
    "accept": "Aceptar",
    "access": "Acceso",
    "accessControlTable": "Tabla de control de acceso (TCA)",
    "accessibility": "Accesibilidad",
    "accessType": "Tipo de acceso",
    "aConsecutiveWithTheCode'#numerodecódigo#'AlreadyExists.": "Ya existe un consecutivo con el código '#numerodecódigo#'",
    "actingAsARepresentative": "¿Actúa cómo apoderado?",
    "activateBranches": "Activar sucursal(es)",
    "activateProfiles": "Activar perfil(es)",
    "active_Female": "Activa",
    "active_Male": "Activo",
    "activeInTheElectronicOffice": "Activo en la sede electronica",
    "activeTRD": "TRD activa",
    "actsAsARepresentative": "¿Actua como representante?",
    "actuaComoRepresentanteQuestion": "¿Actúa cómo representante?",
    "add": "Agregar",
    "addANewKeyword": "Agregar una nueva palabra clave",
    "addAttachmentType": "Agregar tipo de anexo",
    "addDocumentType": "Agregar tipo documental",
    "addExternalCopy": "Agregar copia externa",
    "addFolder": "Agregar carpeta",
    "additionalInformation": "Información adicional",
    "addKeyword": "Agregar Palabra",
    "addLocation": "Agregar ubicación",
    "address": "Direccion",
    "addressRequired": "Dirección requerida",
    "aDefinitiveAnswerHasBeenGivenWithThePhysicalOutgoingRecordNo.#RecordNumber#": "Se ha dado respuesta definitiva con el radicado de salida físico No. # numero radicado #",
    "administration": "Administración",
    "administrativeClosure": "Cierre administrativo",
    "administrativeClosureOfTheRecordCompleted": "Cierre administrativo de expediente realizado",
    "administrativeClosureSuccessfullyCompleted": "Cierre administrativo realizado correctamente",
    "advancedOrientationSearch": "Búsqueda avanzada de orientaciones",
    "advancedSearch": "Búsqueda avanzada",
    "advancedSearchForRecordsAndInternalCommunications": "Búsqueda avanzada de radicados y comunicados internos",
    "ageRange": "Rango de edad",
    "ageRanges": "Rangos de edad",
    "aHolidayWithTheDate#Date#AlreadyExists": "Ya existe un día festivo con la fecha #Fecha#",
    "alertCreatedSuccessfully": "Alerta creada correctamente",
    "alerts": "Alertas",
    "all": "Todo",
    "allowedExtensions": "Extensiones permitidas",
    "allowEditing": "Permitir editar",
    "allowReassignment": "Permitir reasignar",
    "allowReturn": "permitir devolver",
    "allSections": "Todas las secciones",
    "allTaskTypes": "Todos los tipos de tarea",
    "aNewVersionOfTheApplicationHasBeenDownloaded,SoThePageWillBeUpdated.IfThisMessagePersists,PressTheCtrl+F5Key": "Se ha descargado una nueva versión de la aplicación por lo cual se va a actualizar la página. Si este mensaje persiste, presione la tecla Ctrl + F5",
    "annotations": "Anotaciones",
    "anonymous": "Anónimo",
    "anonymousFiling": "Radicación anónima",
    "aParameterWithTheName'#nombre#'AlreadyExistsInTheGroup'#grupo#'": "Ya existe un parámetro con nombre '#nombre#' en el grupo '#grupo#'",
    "applications": "Aplicaciones",
    "approval": "Visto bueno",
    "approvalComments": "Observaciones de la aprobación",
    "approvalDenied": "Aprobación Rechazada",
    "approvalOfFileTransferByDepartment": "Aprobación de Transferencia de expedientes por Dependencia",
    "approvalOfIncomingMail-DocumentFlow": "Aprobación radicado de entrada - Flujo documental",
    "approvalOfRecordTransfer": "Aprobación traslado de expedientes",
    "approvalPending": "Pendiente por aprobar",
    "approvalRequest": "Solicitud de visto bueno",
    "approvalRequestSentSuccessfully": "Solicitud de aprobación enviada con éxito",
    "approve": "Aprobar",
    "approved": "Aprobado",
    "approveFinalStepOfOutgoingMailDocumentFlow": "Aprobar final flujo documental radicado de salida",
    "approveInternalCommunication": "Aprobar comunicado interno",
    "approveOutgoingMail": "Aprobar radicado de salida",
    "approveOutgoingMailWithDigitalSignature": "Aprobar radicado de salida con firma digital",
    "approveOutgoingPQR": "Aprobar PQR salida",
    "approvePostponingTransfers": "Aprobar posponer transferencias",
    "approver": "Aprobador",
    "approverUser": "Usuario aprobador",
    "approverUserSubsection": "Subsección usuario aprobador",
    "approverUserUpdatedSuccessfully": "Usuario aprobador actualizado con éxito.",
    "approveStepInOutgoingMailDocumentFlow": "Aprobar paso flujo documental radicado de salida",
    "approveTransfers": "Aprobar transferencias",
    "archive": "Archivar",
    "archiveIncomingFile": "Archivar radicado de entrada",
    "archivoX_EditNotification": "Editar notificación",
    "areaCode": "Indicativo",
    "areaManager": "Jefe del área",
    "areYouSureYouWantToActivateTheSelectedBranch(es)": "¿Está seguro que desea Activar la(s) sucursal(es) seleccionada(s)",
    "areYouSureYouWantToActivateTheSelectedProfile(s)": "¿Está seguro que desea Activar el(los) perfil(es) seleccionado(s)",
    "areYouSureYouWantToApproveForTheCurrentOutgoingFile": "¿Esta seguro que desea aprobar para el radicado de salida actual?",
    "areYouSureYouWantToApproveTheCurrentInternalCommunication": "¿Está seguro que desea aprobar el comunicado interno actual?",
    "areYouSureYouWantToArchiveTheIncomingFile": "¿Está seguro que desea archivar el radicado de entrada?",
    "areYouSureYouWantToAssociateTheUserWithTheSection": "¿Está seguro que desea asociar el usuario a la sección?",
    "areYouSureYouWantToBreakInheritanceOfRecordPermissions": "¿Está seguro que desea romper la herencia de permisos del expediente?",
    "areYouSureYouWantToBreakThePermissionInheritanceOfTheDocument": "¿Está seguro que desea romper la herencia de permisos del documento?",
    "areYouSureYouWantToChangeTheRecordResponsible": "¿Está seguro que desea cambiar el responsable del expediente?",
    "areYouSureYouWantToCompleteTheShippingAssignment": "¿Está seguro que desea completar la asignación de envio?",
    "areYouSureYouWantToCreateTheCity": "¿Está seguro que desea crear la ciudad?",
    "areYouSureYouWantToCreateTheCountry": "¿Está seguro que desea crear el país?",
    "areYouSureYouWantToCreateTheDecision": "¿Está seguro que desea crear la decisión?",
    "areYouSureYouWantToCreateTheExpedient": "¿Está seguro que desea crear el expediente?",
    "areYouSureYouWantToCreateTheExtension": "¿Está seguro que desea crear la extensión?",
    "areYouSureYouWantToCreateTheFolder": "¿Está seguro que desea crear la carpeta?",
    "areYouSureYouWantToCreateTheFund": "¿Está seguro que desea crear el fondo?",
    "areYouSureYouWantToCreateTheProfile": "¿Está seguro que desea crear el perfil?",
    "areYouSureYouWantToCreateTheRecord": "¿Está seguro que desea crear el registro?",
    "areYouSureYouWantToCreateTheRecordAssociation": "¿Está seguro que desea crear la asociación de expedientes?",
    "areYouSureYouWantToCreateTheRole": "¿Está seguro que desea crear el rol?",
    "areYouSureYouWantToCreateTheSection": "¿Está seguro que desea crear la sección?",
    "areYouSureYouWantToCreateTheSeries": "¿Está seguro que desea crear la serie?",
    "areYouSureYouWantToCreateTheShippingMethod": "¿Está seguro que desea crear el medio de envío?",
    "areYouSureYouWantToCreateTheSubseries": "¿Está seguro que desea crear la subserie?",
    "areYouSureYouWantToCreateTheVersion": "¿Está seguro que desea crear la versión?",
    "areYouSureYouWantToDeactivateTheSelectedBranch(es)": "¿Está seguro que desea Inactivar la(s) sucursal(es) seleccionada(s)?",
    "areYouSureYouWantToDeactivateTheSelectedProfile(s)": "¿Está seguro que desea Inactivar el(los) perfil(es) seleccionado(s)?",
    "areYouSureYouWantToDeleteFileReferencenumber": "¿Esta seguro que desea eliminar el archivo Numeroderadicado?",
    "areYouSureYouWantToDeleteTheAssociatedProperty": "¿Está seguro que desea eliminar la propiedad asociada?",
    "areYouSureYouWantToDeleteTheAssociation": "¿Está seguro que desea eliminar la asociación?",
    "areYouSureYouWantToDeleteTheCommunication?AllRelatedInformationWillBeDeleted": "¿Está seguro que desea eliminar el comunicado? Se eliminará toda la información relacionada.",
    "areYouSureYouWantToDeleteTheDocument": "¿Está seguro que desea eliminar el documento?",
    "areYouSureYouWantToDeleteTheDocumentTypeAssociation": "¿Está seguro que desea eliminar la asociación del tipo documental?",
    "areYouSureYouWantToDeleteTheEntityType": "¿Está seguro que desea eliminar el tipo de entidad?",
    "areYouSureYouWantToDeleteTheFolderAssociation": "¿Está seguero que desea eliminar la asociación de la carpeta?",
    "areYouSureYouWantToDeleteTheLink": "¿Está seguro que desea eliminar el vinculo?",
    "areYouSureYouWantToDeleteTheParameter": "¿Está seguro que desea eliminar el parámetro?",
    "areYouSureYouWantToDeleteThePermission": "¿Está seguro que desea eliminar el permiso?",
    "areYouSureYouWantToDeleteThePhysicalLocation": "¿Está seguro que desea eliminar la ubicación física?",
    "areYouSureYouWantToDeleteTheRecord": "¿Está seguro que desea eliminar el expediente?",
    "areYouSureYouWantToDeleteTheSelectedAlert": "¿Está seguro que desea eliminar la alerta sleccionada?",
    "areYouSureYouWantToDeleteTheSelectedFolder": "¿Está seguro que desea eliminar la carpeta seleccionada?",
    "areYouSureYouWantToDeleteTheSelectedItem": "¿Está seguro que desea eliminar el elemento seleccionado?",
    "areYouSureYouWantToDeleteTheSelectedRecord": "¿Está seguro que desea eliminar el registro seleccionado?",
    "areYouSureYouWantToDeleteTheUser'#login#": "¿Está seguro que desea eliminar el usuario '#login#?",
    "areYouSureYouWantToLinkTheRequest?OnceTheActionIsPerformed,ItCannotBeUndone": "¿Está seguro que desea enlazar la petición? Ya que una vez sea realizada la acción no podrá desvincularla.",
    "areYouSureYouWantToLinkTheRequestsToTheEnteredIncomingFile?PleaseNoteThatThisProcessCannotBeReversed": "¿Está seguro que desea enlazar las peticiones al radicado de entrada ingresado? Recuerde que una vez realizado el proceso no se puede reversar.",
    "areYouSureYouWantToMarkTheCommunicationAsRead": "¿Está seguro que desea marcar el comunicado como leído?",
    "areYouSureYouWantToMoveTheDocumentToRecordNo.#RecordNumber#WithThe'radicado'DocumentType": "¿Esta seguro que desea mover el documento al expediente No. #Numero expediente# con el tipo documental radicado?",
    "areYouSureYouWantToPackTheRecord": "¿Está seguro que desea empaquetar del expediente?",
    "areYouSureYouWantToPerformTheAdministrativeClosureOfTheRecord": "¿Está seguro que desea realizar el cierre administrativo del expediente?",
    "areYouSureYouWantToReassignTheInternalCommunicationToTheUser'Username'": "¿Está seguro que desea reasignar el comunicado interno al usuario 'Nombredelusuario'?",
    "areYouSureYouWantToReassignTheTasksToUser#User#": "¿Está seguro de reasignar las tareas al usuario #Usuario#?",
    "areYouSureYouWantToRejectTheApprovalRequest": "¿Está seguro que desea rechazar la solicitud de visto bueno?",
    "areYouSureYouWantToRejectTheCurrentInternalCommunication": "¿Está seguro que desea rechazar el comunicado interno actual?",
    "areYouSureYouWantToReopenTheRecord": "¿Está seguro que desea reabrir el expediente?",
    "areYouSureYouWantToRequestApproval": "¿Está seguro que desea solicitar aprobación?",
    "areYouSureYouWantToResetRecordPermissionsInheritance": "¿Está seguro que desea restablecer la herencia de permisos del expediente?",
    "areYouSureYouWantToResetThePermissionInheritanceOfTheDocument": "¿Está seguro que desea restablecer la herencia de permisos del documento?",
    "areYouSureYouWantToRespondToTheApprovalRequest": "¿Está seguro que desea responder la solicitud de visto bueno?",
    "areYouSureYouWantToSaveTheChanges": "¿Está seguro que desea guardar los cambios?",
    "areYouSureYouWantToSaveTheContact": "¿Está seguro que desea guardar el contacto?",
    "areYouSureYouWantToSaveTheDocumentType": "¿Está seguro que desea guardar el tipo documental?",
    "areYouSureYouWantToSaveTheMetadata": "¿Está seguro que desea guardar los metadatos?",
    "areYouSureYouWantToSaveThePhysicalLocation": "¿Está seguro que desea guardar la ubicación física?",
    "areYouSureYouWantToSaveTheProcedure": "¿Está seguro que desea guardar el tramite?",
    "areYouSureYouWantToSaveTheProcess": "¿Está seguro que desea guardar el trámite?",
    "areYouSureYouWantToSendTheRequest": "¿Está seguro que desea enviar la solicitud?",
    "areYouSureYouWantToSetTheVersion#VersionName#AsTheCurrentDocumentRetentionTableVersion": "¿Está seguro que desea establecee la versión #Nombre versión# como la versión actual de tabla de retención documental?",
    "areYouSureYouWantToUpdateSecurity": "¿Está seguro que desea actualizar la seguridad?",
    "areYouSureYouWantToUpdateTheContactType": "¿Está seguro que desea actualizar el tipo de contacto?",
    "areYouSureYouWantToUpdateTheDecisionTable": "¿Está seguro que desea actualizar la tabla de decisión?",
    "areYouSureYouWantToUpdateTheSecurityLevel": "¿Está seguro que desea actualizar el nivel de seguridad?",
    "areYouSureYouWantToUpdateTheUser'sSection": "¿Está seguro que desea actualizar la sección del usuario?",
    "areYouSureYouWantToUploadTheDeliveryVoucher": "¿Está seguro que desea cargar el comprobante de entrega?",
    "assign": "Asignar",
    "assignedForDispatch": "Asignado para envío",
    "assignment": "Asignación",
    "assignmentByClassification": "Asignación por Clasificación",
    "assignmentByProfile": "Asignación por perfil",
    "assignmentType": "Tipo de asignación",
    "assignShipment": "Asignar envío",
    "associateContact": "Asociar a contacto",
    "associatedBySection": "Asociados por sección",
    "associatedDocumentType": "Tipo documental asociado",
    "associatedKeywords": "Palabras claves asociadas",
    "associatedMetadata": "Metadatos asociados",
    "associateDocumentTypes": "Asociar tipos documentales",
    "associatedOutboundFiles": "Radicados de salida asociados",
    "associatedRecords": "Expedientes asociados",
    "associateRoleWithButton": "Asociar rol a botón",
    "associateUser": "Asociar usuario",
    "associationCreatedSuccessfully": "Asociación creada correctamente",
    "associationDeletedSuccessfully": "Asociación eliminada correctamente",
    "attachments": "Anexos",
    "attachmentType": "Tipo de anexo",
    "author": "Autor",
    "authorizedRoles": "Roles autorizados",
    "authorizeNotificationByEmail": "¿Autoriza notificación por correo electrónico?",
    "authorizeNotificationOrReceiveCallsOnTheCellPhone": "¿Autoriza notificación o recibir llamadas por télefono celular? ",
    "authorizeToReceiveCallsOnTheLandline": "¿Autoriza recibir llamadas en el télefono fijo?",
    "authorizeToReceiveNotificationAtTheRegisteredAddress": "¿Autoriza recibir notificación en la dirección registrada?",
    "awaitingDigitalSignatureApproval": "Pendiente aprobación firma digital",
    "axpayerIdentificationNumber(TIN)": "NIT",
    "basicInformation": "Información básica",
    "belongs": "Pertenece",
    "birthCertificate": "Registro civil",
    "box": "Caja",
    "branch": "Sucursal",
    "branches": "Sucursales",
    "branchStoredSuccessfully": "Sucursal almacenada correctamente",
    "breakInheritance": "Romper herencia",
    "bulkUpload": "Carga masiva",
    "businessName": "Razón social",
    "cancel": "Cancelar",
    "canceled": "Anulado",
    "cancellationRequest": "Solicitud anulación",
    "cancellations": "Anulaciones",
    "cancelRequest": "Cancelar solicitud",
    "caseFileDeletedSuccessfully": "Expediente eliminado correctamente",
    "caseFileNumber": "Numero expediente",
    "caseFiles": "Expedientes",
    "caseFileTitle": "Título del expediente",
    "category": "Categoría",
    "cellPhone": "Celular",
    "center": "Centro",
    "centralArchive": "Archivo central",
    "centralArchive(Years)": "Archivo central (Años)",
    "certifiedMail": "Correo certificado",
    "changeApprover": "Cambiar aprobador",
    "changeApproverUser": "Cambiar usuario aprobador",
    "changeHistory": "Historial de cambios",
    "changeName": "Cambiar nombre",
    "changeResponsible": "Cambiar responsable",
    "changeSection": "Cambiar sección",
    "changesSavedSuccessfully": "Cambios almacenados correctamente",
    "checkSheets": "Consultar planillas",
    "chooseAnOption": "Elija una opción",
    "chronologicalOrder": "Orden cronológico",
    "cities": "Ciudades",
    "citizen": "Ciudadano",
    "citizenshipID": "Cédula de ciudadanía",
    "city": "Ciudad",
    "cityRequired": "Ciudad requerida",
    "clarificationContribution": "Aporte de aclaración",
    "classification": "Clasificación",
    "classificationAndCodingPlan(CCD)": "Cuadro de clasificación documental (CCD)",
    "classificationSavedSuccessfully": "Clasificación almacenada correctamente",
    "classified": "Clasificado",
    "classifiedInformation": "Información clasificada",
    "clear": "Limpiar",
    "clearFilters": "Limpiar filtros",
    "clickHereToDownloadSignaX": "Haga clic aquí para descargar SignaX",
    "clickHereToSeeTheDetailsOfSection#Section#": "Haga clic aqui para ver los detalles de la sección # sección #",
    "clickOnceResources": "Recursos de ClickOnce",
    "close": "Cerrar",
    "closedUserSelection": "Selección cerrada de usuarios",
    "closeMulti-assignment": "Cerrar multiasignación",
    "closure": "Cierre",
    "code": "Código",
    "collected": "Recolectado",
    "completeAssignment": "Completar asignación",
    "completed": "Completas",
    "componentToRender": "Componente a renderizar",
    "configuration": "Configuración",
    "configureSignature": "Configurar firma",
    "congratulations": "Felicitación",
    "consecutive": "Consecutivo",
    "consecutives": "Consecutivos",
    "consecutiveSuccessfullyStored": "Consecutivo almacenado correctamente",
    "conservation": "Conservación",
    "consultMinutes": "Consultar acta",
    "contact": "Contacto",
    "contactIdentificationNumber": "Número de identificación contacto",
    "contactInformation": "Datos del contacto",
    "contacts": "Contactos",
    "contactsCharacterization": "Caracterización contactos",
    "contactStoredCorrectly": "Contacto almacenado correctamente",
    "contactType": "Tipo contacto",
    "contactTypes": "Tipos de contacto",
    "contactTypeUpdatedSuccessfully": "Tipo de contacto actualizado correctamente",
    "copies": "Copias",
    "copy-IncomingMail": "Copia - Radicado de entrada",
    "copy": "Copia",
    "copyActiveDocumentaryTypes": "Copiar tipos documentales activos",
    "copyActiveFolders": "Copiar carpetas activas",
    "copyOfIncomingFile": "Copia radicado de entrada",
    "correspondence": "Correspondencia",
    "counterRegistration": "Registro ventanilla",
    "counterRegistration(PhysicalIncomingMail)": "Registro ventanilla (Radicado de entrada fisico)",
    "countries": "Paises",
    "country": "País",
    "create": "Crear",
    "createAssociation": "Crear asociación",
    "createCity": "Crear ciudad",
    "createColumn": "Crear columna",
    "createCountry": "Crear país",
    "createdBy": "Creado por",
    "createDecision": "Crear decisión",
    "createDepartment": "Crear departamento",
    "createDigitalIncomingFile": "Crear radicado de entrada digital",
    "createFile": "Crear expediente",
    "createFolder": "Crear carpeta",
    "createFund": "Crear fondo",
    "createHoliday": "Crear día festivo",
    "createMetadata": "Crear metadato",
    "createNewItem": "Crear nuevo elemento",
    "createOrientation": "Crear orientación",
    "createPermission": "Crear permiso",
    "createPhysicalIncomingFile": "Crear radicado de entrada fisico",
    "createProcess": "Crear trámite",
    "createProfile": "Crear perfil",
    "createResponseProject": "Crear proyecto de respuesta",
    "createRole": "Crear rol",
    "createSection": "Crear sección",
    "createSeries": "Crear serie",
    "createShippingMethod": "Crear medio de envío",
    "createSubseries": "Crear subserie",
    "createTerminologyBank": "Crear Banco Terminológico",
    "createTransferSchedule": "Crear Cronograma de Transferencia",
    "createVersion": "Crear versión",
    "createVersionNumber": "Crear número de versión",
    "creatingDecision": "Creando decisión",
    "creation": "Creación",
    "creationDate": "Fecha de creación",
    "creationOfPhysicalIncomingRecord": "Creación radicado de entrada físico",
    "custodyCompany": "Empresa custodia",
    "custom": "Personalizado",
    "customField#No.#": "Campo personalizado #No.#",
    "dataTypes": "Tipos de dato",
    "date": "Fecha",
    "dateOfBirth": "Fecha de nacimiento",
    "day": "Día",
    "deactivate": "Inactivar",
    "deactivateBranch(es)": "Inactivar sucursal(es)",
    "deactivateProfile(s)": "Inactivar perfil(es)",
    "decisionName": "Nombre decisión",
    "decisions": "Decisiones",
    "decisionStoredSuccessfully": "Decisión almacenada correctamente",
    "decisionTable": "Tabla de decisión",
    "decisionTableDeletedSuccessfully": "Tabla de decisión eliminada correctamente",
    "decisionTables": "Tablas de decisión",
    "default": "Predeterminado",
    "defaultUser": "Usuario predeterminado",
    "definitiveAnswer": "Respuesta definitiva",
    "delete": "Eliminar",
    "deleteAlert": "Eliminar alerta",
    "deleteAssociation": "Eliminar asociación",
    "deleteCurrentAlert": "Elimina la alerta actual",
    "deleteDecisionTable": "Eliminar tabla de decisión",
    "deleteDocument": "Eliminar Documento",
    "deleteDocumentRetentionTable": "Eliminar TRD",
    "deleteDocumentType": "Eliminar tipo documental",
    "deleteEntityType": "Eliminar tipo de entidad",
    "deleteFile": "Eliminar archivo",
    "deleteFolder": "Eliminar carpeta",
    "deleteIncomingFile": "Eliminar radicado",
    "deleteInternalCommunication": "Eliminar comunicado interno",
    "deleteItem": "Eliminar elemento",
    "deleteLink": "Eliminar vinculo",
    "deletePermission": "Eliminar permiso",
    "deleteRecord": "Eliminar expediente",
    "deletionReason": "Motivo de eliminación",
    "delivered_Plural": "Entregados",
    "delivered_Singular": "Entregado",
    "deliveryVoucher": "Comprobante de entrega",
    "deliveryVouchers": "Comprobantes entrega",
    "department": "Departamento",
    "departments": "Departamentos",
    "description": "Descripción",
    "descriptionOfTheOrientation": "Descripción de la orientación",
    "desktopRuntimeEnvironment": "Entorno de ejecución de escritorio",
    "details": "Detalles",
    "didTheOrientationGeneratePQR": "¿Orientación generó PQR?",
    "didTheReceivedServiceMeetYourExpectations": "¿El servicio recibido cumplió con sus expectativas?",
    "digitalIncomingFile": "Radicado de entrada digital",
    "digitalIncomingFileSignature": "Firma Radicados Digitales",
    "digitalOutgoingFile": "Radicado de salida digital",
    "digitalPQRNo": "PQR digital No. ",
    "digitalRecordCreatedAndAssignedTo#User#": "Radicado digital creado y asignado a # usuario #",
    "digitalRecordDraftCreatedByTheUser": "Radicado digital creado en borrador por el usuario",
    "digitalSignature": "Firma digital",
    "digitizationOfIncomingRecords": "Digitalización de Radicados de Entrada",
    "digitizationOfOutgoingRecords": "Digitalización de Radicados de salida",
    "digitized_Plural": "Digitalizados",
    "digitized_Singular": "Digitalizado",
    "digitizedByMe": "Digitalizados por mi",
    "disabilities": "Discapacidades",
    "discard": "Descartar",
    "displaysAllPendingOutgoingMailsForCancellation": "Muestra todos los radicados de salida pendientes por anular",
    "distribution": "Distribución",
    "distributions": "Distribuciones",
    "documentalType": "Tipo documental",
    "documentaryInventory": "Inventario documental",
    "documentaryInventoryReport": "Reporte Inventario Documental",
    "documentaryType": "Tipo documental",
    "documentAuthor": "Autor del documento",
    "documentCreatedWithNumber#number#": "Documento creado con número #numero#",
    "documentDate": "Fecha de documento",
    "documentDeliveries": "Entregas documentales",
    "documentDescription": "Descripción documental",
    "documentFlowExecution": "Ejecución flujo documental",
    "documentInventoryTemplates": "Plantillas inventario documental",
    "documentManager": "Gestor documental",
    "documentName": "Nombre documento",
    "documentNumber": "Número de documento",
    "documento": "Documento",
    "documentRetentionTableCreatedSuccessfully": "Tabla de retención documental creada correctamente",
    "documentRetentionTableImportedFromExcel": "Tabla de retención documental importada desde Excel",
    "documentRetentionTables": "Tablas de retención documental",
    "documentRetentionTableVersions": "Versiones de tablas de retención documental",
    "documents": "Documentos",
    "documentSource": "Origen documento",
    "documentsPendingReceipt": "Documentos pendientes por recibir",
    "documentsReceivedSuccessfully": "Documentos recibidos correctamente",
    "documentTitle": "Título del documento",
    "documentType": "Tipo Documento",
    "documentType#FolderName#Added": "Se agrego tipo documental #Nombre de la carpeta#",
    "documentTypeDeleted": "Tipo documental eliminado",
    "documentTypeOrigin": "Origen tipo documental",
    "documentTypeStoredSuccessfully": "Tipo documental almacenado correctamente",
    "documentUpdatedSuccessfully": "Documento actualizado correctamente",
    "documentValuationTableVersions": "Versiones de tablas de valoración documental",
    "documentVersions": "Versiones del documento",
    "documentViewer": "Visor de documentos",
    "download": "Descargar",
    "downloadAll": "Descargar todos",
    "downloadFiltered.": "Descargar filtrados",
    "downloadMetadata": "Descargar metadatos",
    "downloadTemplate": "Descargar plantilla",
    "downloadTheBulkUploadTemplate": "Descarga la plantilla de carga masiva ",
    "doYouConsiderTheReceivedInformationUseful": "¿Considera útil la información recibida?",
    "doYouWantToCompleteTheSurvey": "Desea diligenciar encuesta",
    "draft": "Borrador",
    "draftIncomingFileDeletedSuccessfully": "Radicado de entrada en borrador eliminado correctamente",
    "draftingResponseToInternalCommunication": "Elaboración respuesta comunicado interno",
    "dragAFileOrClickToSelect": "Suelte un archivo o haga click para seleccionar. *",
    "dragFilesOrClickBelowThisTitleToSelect": "Arrastre archivos o haga clic abajo de este título para selleccionar",
    "dropAFileOrClickToSelect": "Suelte un archivo o haga clic para seleccionar",
    "dVD": "DVD",
    "east": "Oriente",
    "edit": "Editar",
    "editAlert": "Editar alerta",
    "editConsecutive": "Editar consecutivo",
    "editContact": "Editar contacto",
    "editContactType": "Editar tipo de contacto",
    "editDocumentType-TRD": "Editar tipo documental - TRD",
    "editFund": "Editar fondo",
    "editHoliday": "Editar día festivo",
    "editing": "Edición",
    "editor": "Editor",
    "editPQRSClassification": "Editar clasificación PQRS",
    "editProcedure": "Editar trámite",
    "editRules": "Editar reglas",
    "editSectionTRD": "Editar sección - TRD",
    "editSeriesTRD": "Editar serie - TRD",
    "editShippingMethod": "Editar medio de envío",
    "editTemplate": "Editar plantilla",
    "editTRDSubseries": "Editar subserie TRD",
    "editVersion": "Editar versión",
    "educationalLevel": "Nivel de escolaridad",
    "educationalLevels": "Niveles educativos",
    "electronic": "Electrónico",
    "electronicIndex": "Índice electrónico",
    "electronicIndexExportedAsXML": "Indice electrónico exportado como XML",
    "electronicResponse": "Respuesta electrónica",
    "electronicSignature": "Firma Eléctronica",
    "elementsByPage": "Elementos por pagina",
    "emailAddress": "Correo electrónico",
    "emailNotifications": "Notificaciones de correo",
    "enableAnotherPQRSClassification": "Habilitar otra clasificación PQRS",
    "enableBetaFeatures": "Habilitar características beta",
    "encryptOnSave": "Cifrar al guardar",
    "end": "Fin",
    "endDate": "Fecha de fin",
    "enddate": "Fecha final",
    "endDateOfRecordCreation": "Fecha fin creación expediente",
    "entity": "Entidad",
    "entityType": "Tipo de entidad",
    "entityTypeDeletedSuccessfully": "Tipo de entidad eliminado correctamente",
    "entityTypes": "Tipos de entidad",
    "entityTypeSavedSuccessfully": "Tipo de entidad guardado correctamente",
    "error": "Error",
    "ethnicGroups": "Grupos étnicos",
    "excel": "Excel",
    "executionType": "Tipo ejecución",
    "exitFullScreen": "Salir de pantalla completa",
    "expiry": "Vencimiento",
    "export": "Exportar",
    "exportAll": "Exportar todos",
    "exportAllPages": "Exportar todas las páginas",
    "exportAllPagesAsTemplates": "Exportar todas las páginas como plantilla",
    "exportAsTXT": "Exportar TXT",
    "exportAsXML": "Exportar como XML",
    "exportCurrentPage": "Exportar página actual",
    "exportCurrentPageAsATemplate": "Exportar página actual como plantilla",
    "exportCurrentResults": "Exportar los resultados actuales",
    "exportDirectory": "Exportar directorio",
    "exportFiltered": "Exportar filtrados",
    "exportMetadata": "Exportar metadatos",
    "exportToPDF": "Exportar a PDF",
    "extension": "Extension",
    "extensionOfIncomingMail": "Prorroga Radicado entrada",
    "extensions": "Extensiones",
    "extensionsDeletedSuccessfully": "Extensiones eliminadas correctamente",
    "external": "Externo",
    "externalCopies": "Copias externas",
    "externalDocument": "Documento externo",
    "externalField": "Campo externo",
    "favorites": "Favoritos",
    "fAX": "FAX",
    "fieldType": "Tipo de campo",
    "file": "Expediente",
    "fileDeleted": "Archivo eliminado",
    "fileName": "Nombre archivo",
    "fileNotFound": "No se encontro el archivo",
    "fileStatuses": "Estados de expedientes",
    "fileStorage": "Almacenamiento de archivos",
    "fileTransfer": "Transferencia de expedientes",
    "filter": "Filtrar",
    "filters": "Filtros",
    "finalApproval": "Aprobación final",
    "finalDisposition": "Disposición final",
    "fingerprintValue": "Valor huella",
    "finish": "Finalizar",
    "finishTurno": "Finalizar turno",
    "firstCall": "Primer llamado",
    "firstName": "Nombres",
    "folder": "Carpeta",
    "folder#FolderName#WasAdded": "Se agrego carpeta #Nombre de la carpeta#",
    "folder#FolderName#WasDeleted": "Se eliminó carpeta #Nombre de la carpeta#",
    "folderDeleted": "Carpeta eliminada",
    "folders": "Carpetas",
    "folderSavedSuccessfully": "Carpeta guardada correctamente",
    "foreigner'sID": "Cédula de extranjería",
    "format": "Formato",
    "from": "Desde",
    "fullScreen": "Pantalla completa",
    "fullView": "Vista completa",
    "function": "Función",
    "functionToExecuteInTheAPI": "Función a ejecutar en el API",
    "fund": "Fondo",
    "fundItBelongsTo": "Fondo al que pertenece",
    "funds": "Fondos",
    "fundStoredSuccessfully": "Fondo almacenado correctamente",
    "gender": "Genero",
    "genders": "Géneros",
    "general": "General",
    "generalSearch": "Búsqueda general",
    "generateSheet": "Generar planilla",
    "geography": "geografía",
    "goToInbox": "Ir a bandeja de entrada",
    "goToRecord": "Ir al expediente",
    "goToSection": "Ir a sección",
    "group": "Grupo",
    "grupoEtnido": "Grupo étnico",
    "guideNumber": "Número de Guía",
    "handwrittenSignature": "Firma manuscrita",
    "headquarters": "Sede",
    "helpdeskRegistration": "Registro mesa de ayuda",
    "helpdeskRegistration(DigitalIncomingMail)": "Registro mesa de ayuda (Radicado de entrada digital)",
    "high_Female": "Alta",
    "high_Male": "Alto",
    "historical": "Histórico",
    "historicalArchive": "Archivo histórico",
    "history": "Histórico",
    "holidays": "Festivos",
    "iD": "ID",
    "identification": "Identificación",
    "identificationnumber": "Numero de identificacion",
    "identificationNumber": "Número de identificación",
    "identificationType": "Tipo de identificacion",
    "identityCard": "Tarjeta de identidad",
    "ifYouChangeTheResponsibleForTheInternalCommunication,UnsavedChangesInTheFormWillBeDeleted.AreYouSureYouWantToUpdateTheApprover": "Si cambia el responsable del comunicado interno, los cambios no guardados en el formulario se borrarán. ¿Está seguro que desea actualizar el aprobador?",
    "ifYouDeleteTheDecisionTable,ItCannotBeRecovered.AreYouSureYouWantToDeleteTheSelectedDecisionTable": "Si elimina la tabla de decisión no se podrá recuperar. ¿Está seguro que desea eliminar la tabla de decisión seleccionada?",
    "ifYouDeleteTheDocumentRetentionTable,TheFolder,DocumentType,AndPermissionSettingsCannotBeRestored.AreYouSureYouWantToContinue": "Si elimina la tabla de retención documental, no se podra restaurar la configuración de carpetas, tipos documentales y permisos. ¿Está seguro que continuar?",
    "ifYouHaveTheseComponentsInstalled,YouCanLaunchTheApplicationNow.Otherwise,ClickTheButtonBelowToInstallThePrerequisitesAndRunTheApplication.": "Si ya tiene instalados estos componentes, puede iniciar ahora la aplicación. De lo contrario, haga clic en el botón de abajo para instalar los requisitos previos y ejecutar la aplicación.",
    "ifYouLockTheRecord,UsersWillNoLongerBeAbleToCreate,Edit,OrDeleteDocuments": "Si bloquea el expediente, los usuarios ya no podran crear, editar o eliminar documentos.",
    "ifYouUnlockTheRecord,UsersWillBeAbleToCreate,Edit,OrDeleteDocuments": "Si desbloquea el expediente, los usuarios podran crear, editar o eliminar documentos",
    "import": "Importar",
    "important": "La asignación de permisos para la visualización de documentos puede tomar varios minutos en completarse.",
    "importProject": "Importar proyecto",
    "inApproval": "En aprobación",
    "inbox": "Bandeja de entrada",
    "inbox#tasksOf#tasks": "Bandeja de entrada #detareas de #detareas",
    "inboxColumns": "Columnas bandeja de entrada",
    "includeInFile": "Incluir en expediente",
    "includeMailInRecord-DocumentFlow": "Incluir radicado en expediente - Flujo documental",
    "inclusion": "Inclusión",
    "incomingFile": "Radicado de entrada",
    "incomingFileArchivedSuccessfully": "Radicado de entrada archivado correctamente",
    "incomingFiledIncoming": "Radicado de entrada radicado",
    "incomingFileInDraft": "Radicado de entrada en borrador",
    "incomingFileInMulti-assignedProgress": "Radicado de entrada en tramite multiasignada",
    "incomingFileNo.#IncomingnumberInProgress#": "Radicado de entrada No. # deradicado en tramite #",
    "incomingFileNo": "Radicado de entrada No.",
    "incomingFileNumber": "Número radicado de entrada",
    "incomingFileService": "Error al eliminar el borrador de radicado de entrada Solicitud inválida, el radicado de entrada a eliminar no se encuentra en estado borrador",
    "incomingMailInProgress": "Radicado de entrada en tramite",
    "incomingMailReport": "Reporte radicados de entrada",
    "incomingRecordNo.#Number#CreatedSuccessfully": "Radicado de entrada No. # numero # creado correctamente",
    "incomingRecordNumber": "Número de radicado de entrada",
    "incomingRecordSuccessfullyDelegated": "Radicado de entrada delegado exitosamente",
    "incompleteIncomingRecords": "Radicado de entrada incompletos",
    "incorporationDate": "Fecha incorporación",
    "informationRequest": "Solicitud de información",
    "informationRequestHistory": "Solicitudes de información",
    "informationRequestResponse": "Respuesta solicitud de información",
    "initials": "Iniciales",
    "inProcess": "En tramite",
    "inputFileNumber": "Número de radicado",
    "inputs": "Entradas",
    "install": "Instalar",
    "internal": "Interno",
    "internalCommunication-ApprovalRequest": "Comunicado interno - Solicitud de aprobación",
    "internalCommunication-Rejected": "Comunicado interno - Rechazado",
    "internalCommunication": "Comunicado interno",
    "internalCommunicationApprovedSuccessfully": "Comunicado interno aprobado con éxito.",
    "internalCommunicationCreatedSuccessfully": "Comunicado interno creado con éxito.",
    "internalCommunicationDelegatedSuccessfully": "Comunicado interno delegado exitosamente",
    "internalCommunicationDeletedSuccessfully": "Comunicado interno eliminado con éxito.",
    "internalCommunicationInProgress": "Comunicado interno en trámite",
    "internalCommunicationMarkedAsReadSuccessfully": "Comunicado interno marcado como leído con éxito",
    "internalCommunicationProject": "Proyecto de comunicado interno",
    "internalCommunicationRejectedSuccessfully": "Comunicado interno rechazado con éxito.",
    "internalCommunicationResponseDrafting#internalcommunication": "Elaboración respuesta a comunicado interno #comunicadointerno",
    "internalCommunicationsReport": "Reporte comunicados internos",
    "internalNotifications": "Notificaciones internas",
    "internalProcedure": "Tramite interno",
    "international": "Internacional",
    "inThisSection,YouWillFindTheUsersResponsibleForProjectingAndApprovingInternalCommunication": "En este apartado se encuentran los usuarios encargados de proyectar y aprobar la comunicacion interna",
    "invalidRequest,TheIncomingFileCannotHaveAPreviouslyAssignedNumber": "Solicitud inválida, el radicado de entrada no puede tener un número previamente asignado.",
    "invoice": "Factura",
    "itemDeleted": "Elemento eliminado",
    "itemDeletedSuccessfully": "Elemento eliminado correctamente",
    "itemType": "Tipo de elemento",
    "itIsAllInformationThatASubjectObligatedGenerates,Obtains,Acquires,OrControlsInTheirCapacityAsSuch.Law1712/2014ThatHasBeenLegallyDeclaredOrByItsOwner,PubliclyKnownAndAccessibleToAnyone.E.g.,AccountabilityPresentedByTheEntity,ActionPlanOfTheEntity,OpenData,AmongOthers": "Es toda información que un sujeto obligado genere, obtenga, adquiera, o controle en su calidad de tal. Ley 1712/2014 que ha sido declarada legalmente o por su propietario, de conocimiento público y accesible a cualquier persona. Ej. Rendición de cuentas presentada por la entidad, Plan de acción de la Entidad, datos abiertos, entre otros",
    "itIsThatInformationThat,BeingInThePossessionOrCustodyOfASubjectObligatedInTheirCapacityAsSuch,BelongsToTheOwn,Private,OrSemi-privateSphereOfANaturalOrLegalPerson,SoItsAccessMayBeDeniedOrExcepted,ProvidedThatItInvolvesLegitimateAndNecessaryCircumstancesAndTheParticularOrPrivateRightsEnshrinedInArticle18OfThisLaw;Law1712/2014": "Es aquella información que estando en poder o custodia de un sujeto obligado en su calidad de tal, pertenece al ámbito propio, particular y privado o semiprivado de una persona natural o jurídica por lo que su acceso podrá ser negado o exceptuado, siempre que se trate de las circunstancias legítimas y necesarias y los derechos particulares o privados consagrados en el artículo 18 de esta ley; Ley 1712/2014",
    "itIsThatInformationWhich,BeingInThePossessionOrCustodyOfASubjectObligatedInTheirCapacityAsSuch,IsExemptFromAccessByTheCitizenryDueToHarmToPublicInterestsAndInComplianceWithAllTheRequirementsEstablishedInArticle19OfThisLaw;Law1712/2014": "Es aquella información que estando en poder o custodia de un sujeto obligado en su calidad de tal, es exceptuada de acceso a la ciudadanía por daño a intereses públicos y bajo cumplimiento de la totalidad de los requisitos consagrados en el artículo 19 de esta ley; Ley 1712/2014",
    "itWasNotPossibleToConnectToTheSignaXApplication.PleaseMakeSureTheApplicationIsInstalledAndRunningCorrectly": "No fue posible conectarse a la aplicación SignaX. Por favor asegurese que la aplicación esta instalada y se ejecuta correctamente",
    "jobTitle": "Cargo",
    "keyword": "Palabra clave",
    "keywords": "Palabras clave",
    "landlinePhoneExtensionNumberRequired": "Número de extensión teléfono fijo requerido",
    "landlinePhoneRequired": "Teléfono fijo requerido",
    "lastName": "Apellidos",
    "libraries": "Librerias",
    "link": "Enlazar",
    "linkDeletedSuccessfully": "Enlace eliminado correctamente",
    "linkedDocument": "Documento enlazado",
    "linkedFiles": "Radicados vinculados",
    "linkRequests": "Enlazar Peticiones",
    "loadExtension": "Cargar extensión",
    "loading": "Cargando",
    "loadingDocuments": "Cargando documentos",
    "loadingForm": "Cargando formulario",
    "loadingImportantFileInformation": "Cargando información importante del expediente",
    "loadMoreItems": "Cargar mas elementos",
    "loadMoreTasks": "Cargar mas tareas",
    "loadServerExtension": "Cargar extensión de servidor",
    "loadUI": "Cargar UI",
    "loadUIExtension": "Cargar extensión UI",
    "local": "Local",
    "location": "Ubicación",
    "locationDeletedSuccessfully": "Ubicación eliminada correctamente",
    "locationSavedSuccessfully": "Ubicación almacenada correctamente",
    "lock": "Bloqueo",
    "lockRecord": "Bloquear expediente",
    "loginName": "Login name",
    "low": "Bajo",
    "magazine": "Revista",
    "mainFile": "Archivo principal",
    "mainRecipients": "Destinatarios principales",
    "managementArchive(Years)": "Archivo de gestión (Años)",
    "managementFileReport": "Reporte archivo gestión",
    "manageTrays": "Gestionar bandejas",
    "markAsRead.": "Marcar como leído",
    "mAS": "Módulo de atención y servicio",
    "massDocumentSigning": "Firma masiva de documentos",
    "maximumLength": "Longitud máxima",
    "maximumResponseDate": "Fecha maxima de respuesta",
    "maximumResponseTime": "Tiempo máximo de respuesta",
    "meansOfOrientation": "Medio de la orientación",
    "meansOfReception": "Medio de recepción",
    "mediaType": "Tipo soporte",
    "medium_Female": "Media",
    "medium_Male": "Medio",
    "metadata_Plural": "Metadatos",
    "metadata_Singular": "Metadato",
    "metadataCategories": "Categorías de metadatos",
    "metadataForIncomingMail": "Metadatos radicado entrada",
    "metadataForOutgoingMail": "Metadatos radicado salida",
    "metadataSuccessfullyStored": "Metadatos almacenados correctamente",
    "minimumLength": "Longitud minima",
    "mobilePhoneRequired": "Teléfono celular requerido",
    "modificationDate": "Fecha modificación",
    "modifiedBy": "Modificado por",
    "moduleName": "Nombre del módulo",
    "modules": "Módulos",
    "month": "Mes",
    "moveDocument": "Mover documento",
    "moveToFolder": "Mover a carpeta",
    "multi-assigned": "Multiasignados",
    "multi-assignment": "Multiasignación",
    "myApprovals": "Mis aprobaciones",
    "myFUID": "Mis FUID",
    "myRequests": "Mis solicitudes",
    "name": "Nombre",
    "nameOrLegalEntity": "Nombre o razón social",
    "namesOrBusinessName": "Nombres o razón social",
    "national": "Nacional",
    "neighborhood": "Barrio",
    "neighborhoodRequired": "Barrio requerido",
    "new": "Nuevo",
    "newAlert": "Nueva alerta",
    "newBusinessUser": "Nuevo usuario empresarial",
    "newContact": "Nuevo contacto",
    "newDecision": "Nueva decisión",
    "newDocumentRetentionTable": "Nueva tabla de retención documental",
    "newDocumentType-TRD": "Nuevo tipo documental - TRD",
    "newFolder": "Nuevo carpeta",
    "newFund": "Nuevo fondo",
    "newPQRSClassification": "Nueva clasificación PQRS",
    "newProcedure": "Nuevo trámite",
    "newRule": "Nueva regla",
    "newSeries-TRD": "Nueva serie - TRD",
    "newShippingMethod": "Nuevo medio de envío",
    "newUser": "Nuevo usuario",
    "newZone": "Nueva zona",
    "next": "Siguiente",
    "nextTurno": "Siguiente turno",
    "no": "No",
    "noDataToDisplayAtThisTime": "No hay datos para mostrar en este momento",
    "noDocumentsWereAttached": "No se adjuntaron documentos",
    "noInformationToDisplay": "No hay información para mostrar",
    "noInformationToDisplayAtThisTime": "No hay información para mostrar en este momento",
    "noMatchingDataFoundForTheSearchFilters": "No se encontraron datos que coincidan con los filtros de búsqueda",
    "none": "Ninguno",
    "noRecordsToDisplay": "No hay registros para mostrar",
    "noResultsWereFoundForTheEnteredSearchCriteria": "No se encontraron resultados para los criterios de búsqueda ingresados.",
    "north": "Norte",
    "note": "Nota",
    "notifications": "Notificaciones",
    "notificationsToBeSent": "Notificaciones por enviar",
    "number": "Número",
    "numberOfPages": "Cantidad de folios",
    "numeroReferencia": "Número de referencia",
    "observations": "Observaciones",
    "occupationOrProfession": "Ocupación u oficio",
    "onlyUsersOfSection#sectionName#CanBeSetAsRecordResponsibles": "Solo los usuarios de la sección #nombre de la sección# puedes establecerse como responsables del expediente.",
    "openUserSelection": "Selección abierta de usuarios",
    "operation": "operación",
    "operationPerformedSuccessfully": "Operación efectuada correctamente",
    "order": "Orden",
    "orientation": "Orientación",
    "orientationNumber": "Número de orientación",
    "orientationReceptionMethods": "Medios de recepción orientación",
    "orientationSectors": "Sectores orientación",
    "origin": "Origen",
    "other": "Otro",
    "otherAttachments": "Otros anexos",
    "outgoingMailInProgress": "Radicado de salida en tramite",
    "outgoingMailReport": "Reporte radicados de salida",
    "outgoingMailReturnToElectronicHeadquarters": "Radicado Salida Devolucion Sede Electronica",
    "outputs": "Salidas",
    "pack": "Empaquetar",
    "packagedCaseFiles": "Expedientes empaquetados",
    "packaging": "Empaquetamiento",
    "packRecord": "Empaquetar expediente",
    "paper": "Papel",
    "paperAndElectronic": "Papel y Electrónico",
    "parameterDeletedSuccessfully": "Parámetro eliminado correctamente",
    "parameters": "Parámetros",
    "parameterSavedSuccessfully": "Parámetro almacenado correctamente",
    "parent": "Padre",
    "parentFund": "Fondo padre",
    "parentSection": "Sección padre",
    "password": "Contraseña",
    "pBX": "Pbx",
    "pDFFile": "Archivo * .pdf",
    "pending": "Pendientes",
    "pendingApprovalOfInternalCommunication": "Pendiente aprobación comunicado interno",
    "pendingConservation": "Pendientes conservación",
    "pendingForReceipt": "Pendientes por recibir",
    "pendingQualitativeSelection": "Pendientes selección cualitativa",
    "pendingQuantitativeSelection": "Pendientes selección cuantitativa",
    "pendingRemoval": "Pendientes eliminación",
    "permission": "Permiso",
    "permissions": "Permisos",
    "permissionsWereGrantedToTheSection#sectionName#": "Se concedió permisos a la sección #nombre de la sección#",
    "permissionType": "Tipo de permiso",
    "personalInformation": "Información personal",
    "phone": "Teléfono",
    "physical": "Fisico",
    "physicalAddress": "Dirección fisica",
    "physicalIncomingFile": "Radicado de entrada fisico",
    "physicalIncomingFileSignature": "Firma Radicados Fisicos",
    "physicalLocation": "Ubicación física",
    "physicalOutgoingFile": "Radicado de salida fisico",
    "physicalOutgoingFileProject": "Proyecto de radicado de salida fisico",
    "physicalResponse": "Respuesta fisica",
    "physicalTokenSerial": "Serial token fisico",
    "postalCode": "Código postal",
    "pQRClassification": "Clasificación PQR",
    "pQRNo.#PqrnumberInProgress#.": "PQR No. # de pqr en tramite #",
    "pQROutgoingInProgress": "PQR salida en tramite",
    "pQRSClassifications": "Clasificaciones PQRS",
    "pQRSReport": "Reporte PQRS",
    "pqrWeb": "PqrWeb",
    "preferredAttention": "Atención preferencial",
    "prefix": "Prefijo",
    "preliminaryResponse": "Respuesta preliminar",
    "preview": "Vista previa",
    "primaryTransfer": "Transferencia primaria",
    "primaryTransferEndDate": "Fecha fin transferencia primaria",
    "primaryTransferNumber": "Número transferencia primaria",
    "primaryTransferStartDate": "Fecha inicio transferencia primaria",
    "printed": "Impreso",
    "priority": "Prioridad",
    "procedure": "Trámite",
    "procedureCode": "Código procedimiento",
    "procedureDescription": "Descripción procedimiento",
    "procedureExecutionType": "Tipo de ejecución trámite",
    "procedureName": "Nombre procedimiento",
    "procedures": "Trámites",
    "procedureSavedSuccessfully": "Tramite almacenado correctamente",
    "procesoX_AllowUploadDocumentUsingActivityInstance": "Permitir cargar documentos por medio de la instancia de proceso",
    "procesoX_Function_ExistConstant_ArgumentNullException": "ProcesoxErrors.Functions.ExistConstant.ArgumentNullException",
    "procesoX_ShowErrorsSummaryInDialog": "Mostrar resumen de errores en cuadro de dialogo",
    "process": "Proceso",
    "processCompletedSuccessfully": "Proceso completado correctamente",
    "processInitiatorUser": "Usuario que inicia el flujo",
    "producingOffice": "Oficina productora",
    "profession": "Profesion",
    "professions": "Profesiones",
    "profile": "Perfil",
    "profiles": "Perfiles",
    "projectingUser": "Usuario proyectante",
    "projectingUserSection": "Sección usuario proyectante",
    "projector": "Proyector",
    "properties": "Propiedades",
    "property": "Propiedad",
    "propertyCreatedSuccessfully": "Propiedad creada correctamente",
    "provideAnExtension": "Aportar ampliación",
    "provideInformation": "Aportar información",
    "public": "Público",
    "publicAttention": "Atención público",
    "publicComplaintsAndRequests": "PQR",
    "publicInformation": "Información Pública",
    "publishedInternalCommunication": "Comunicado interno publicado",
    "qualitativeSelection": "Selección Cualitativa",
    "quantitativeSelection": "Selección cuantitativa",
    "quantity": "Cantidad",
    "query": "Consulta",
    "queryFrequency": "Frecuencia de consulta",
    "read,Create,AndEditAllDocumentTypes": "Leer, crear y editar todos los tipos documentales",
    "read,Create,AndEditSpecificDocumentTypes": "Leer, crear y editar tipos documentales especificos",
    "readAllDocumentaryTypes": "Leer todos los tipos documentales",
    "readAllDocumentTypes": "Leer todos los tipos documentales",
    "readSpecificDocumentaryTypes": "Leer tipos documentales especificos",
    "readSpecificDocumentTypes": "Leer tipos documentales especificos",
    "readWriteAllDocumentaryTypes": "Leer, crear y editar todos los tipos documentales",
    "readWriteSpecificDocumentaryTypes": "Leer, crear y editar tipos documentales especificos",
    "reassign": "Reasignar",
    "reassignInternalCommunication": "Reasignar comunicado interno",
    "reassignment": "Reasignación",
    "reassignTask": "Reasignar tarea",
    "reassignTasks": "Reasignar tareas",
    "rECapture": "Captura RE",
    "receive": "Recibir",
    "received": "Recibido",
    "receiveDocuments": "Recibir documentos",
    "receivingPoint": "Punto de radicación",
    "receptionDate": "Fecha de recepción",
    "receptionMode": "Modo de recepción",
    "recipient": "Destinatario",
    "reclassify": "Reclasificar",
    "reconnected": "Reconectar",
    "record#URINumber#HasNoAssociatedDocuments": "El expediente #numero URI# no tiene documentos asociados",
    "recordConsultedByUser#User#": "Radicado consultado por el usuario # usuario #",
    "recordCreated_Audit": "El usuario #USUARIO# ha consultado el expediente",
    "recordCreated": "Se creó expediente",
    "recordCreatedSuccessfully": "Expediente creado correctamente",
    "recordDeletedFromTheManagementFile": "Expediente eliminado del archivo de gestión",
    "recordDeletedSuccessfully": "Registro eliminado correctamente",
    "recordDocumentOrder": "Orden documento expediente",
    "recordHistory": "Historial expediente",
    "recordLink": "Enlace de radicado",
    "recordLocation": "Ubicación del expediente",
    "recordNo.": "Expediente No.",
    "recordNumber": "Número expediente",
    "recordPackaging": "Empaquetamiento de expedientes",
    "recordReopened.Reason": "¿Está seguro que desea reabrir el expediente?",
    "recordReopenedSuccessfully": "Expediente reabierto con éxito",
    "recordReports": "Reportes de expediente",
    "records": "Actas",
    "recordStoredSuccessfully": "Registro almacenado correctamente",
    "recordUnlocked": "Expediente desbloqueado",
    "referenceNumber": "Número de referencia",
    "referralLetter": "Oficio remisorio",
    "refresh": "Actualizar",
    "registerOrientation": "Registrar orientación",
    "reject": "Rechazar",
    "rejectApprovalRequest": "Rechazar solicitud de visto bueno",
    "rejectedApproval": "Rechazado visto bueno",
    "rejectedInternalCommunication": "Comunicado interno rechazada",
    "rejectInternalCommunication": "Rechazar comunicado interno",
    "removal": "Eliminación",
    "rename": "Renombrar",
    "reopening": "Reapertura",
    "reopenRecord": "Reabrir expediente",
    "reports": "Reportes",
    "representative'sName": "Nombre representante",
    "request": "Solicitud",
    "requestApproval": "Solicitar aprobación",
    "requestComments": "Observaciones de la solicitud",
    "requestDate": "Fecha solicitud",
    "requestedOn": "Solicitado el",
    "requestedOn#date#timeAndRespondedOn#date#time(#minutes)": "Solicitado el #fecha #hora y respondido el #fecha #hora (#minutos)",
    "requestInformation": "Solicitar información",
    "requestLinking": "Enlace de peticiones",
    "requestVoBo": "Solicitar visto bueno",
    "required": "Requerido",
    "requiredField": "Campo requerido",
    "requiresResponse": "Requiere respuesta",
    "requiresShippingGuide": "Requiere guía de envío",
    "rescheduleDelivery": "Reagendar envio",
    "resendReturnedPhysicalOutgoingMail": "Reenviar radicado salida fisico devuelto",
    "reserved": "Reservado",
    "reservedInformation": "Información reservada",
    "resetInheritance": "Restablecer herencia",
    "respond": "Responder",
    "respondToApproval": "Responder visto bueno",
    "respondToApprovalRequest": "Responder solicitud de visto bueno",
    "respondToApprovalRequests.": "Responder solicitudes de Vo.Bo",
    "respondToConceptRequest": "Responder solicitud de concepto",
    "respondToInternalCommunication": "Responder comunicado interno",
    "respondToPQRApprovalRequest": "Responder solicitud de visto bueno PQR",
    "respondToRequestForApprovalOfInternalCommunication": "Responder solicitud de visto bueno comunicado interno",
    "respondToVoBoRequest": "Responder solicitud de Vo.Bo",
    "response": "Respuesta",
    "response15TimeUnit": " respuesta 15 Unidad de tiempo",
    "responseDate": "Fecha de respuesta",
    "responsePreference": "Preferencia de la respuesta",
    "responsesToApprovalRequest": "Respuestas solicitud de visto bueno",
    "responsesToApprovalRequests": "Respuestas solicitudes de Vo.Bo",
    "responsesToInformationRequest": "Respuestas solictud de información",
    "responsesToInformationRequests": "Respuestas solicitud de información",
    "responseToInternalCommunication": "Respuesta comunicado interno",
    "responseToRequestForClarification": "Respuesta de solicitud de aclaración",
    "responsible": "Responsable",
    "responsibleAlert": "Alerta responsable",
    "responsibleAlertTime(days)": "Tiempo alerta responsable (días)",
    "responsibleChangedSuccessfully": "Responsable cambiado con éxito",
    "responsibles": "Responsables",
    "responsibleUser": "Usuario Responsable",
    "result": "Resultado",
    "retentionTableViewer": "Visor tabla de retención documental",
    "retentionTimeInCentralArchive(Years)": "Tiempo en archivo central (Años)",
    "retentionTimeInManagementArchive(Years)": "Tiempo en archivo gestión (Años)",
    "return": "Devolver",
    "returned_Plural": "Devueltos",
    "returned_Singular": "Devuelto",
    "returnedComments": "Comentarios de la devolución",
    "returnReasons": "Motivos de devolución",
    "review": "Revisar",
    "role": "Rol",
    "roles": "Roles",
    "roleSavedSuccessfully": "Rol guardado correctamente",
    "router": "Enrutador",
    "rSCapture": "Captura RS",
    "rules": "Reglas",
    "save": "Guardar",
    "saveBranch": "Guardar sucursal",
    "saveChanges": "Guardar cambios",
    "saveConsecutive": "Guardar Consecutivo",
    "saveContact": "Guardar contacto",
    "saveDocumentType": "Guardar tipo documental",
    "saveHoliday": "Guardar festivo",
    "saveMetadata": "Guardar metadatos",
    "savePQRSClassification": "Guardar clasificación PQRS",
    "saveProcedure": "Guardar trámite",
    "saveReturnReason": "Guardar motivo devolución",
    "saveSubseries": "Guardar subserie",
    "saveZone": "Guardar zona",
    "schedule": "Cronograma",
    "scheduleStoredSuccessfully": "Cronograma almacenado correctamente",
    "scope": "Alcance",
    "search": "Buscar",
    "searchDocument": "Buscar documento",
    "searchExistingFile": "Buscar expediente existente",
    "searchForContactsByFilteringByName": "Busca contactos filtrando por el nombre",
    "searchForIncomingFile": "Buscar radicado de entrada",
    "searchForIncomingRecords,OutgoingRecords,AndInternalCommunications,FilteringByNumber": "Buscar radicados de entrada, radicados de salida y comunicados internos, filtrando por número ",
    "searchForUsersOrSections": "Buscar usuarios o secciones",
    "searchInClassifiedAccessRecords": "Búsqueda en expedientes de acceso clasificado ",
    "searchInPublicAccessRecords": "Búsqueda en expedientes de acceso público",
    "searchInReservedAccessRecords": "Búsqueda en expedientes de acceso reservado",
    "searchResult": "Resultado búsqueda",
    "searchTopicsByFilteringByName": "Busca temas filtrando por el nombre ",
    "searchType": "Tipo de búsqueda",
    "seccion": "Sección",
    "secondaryRecipients": "Destinatarios secundarios",
    "serie": "Serie",
    "seriePertenencia": "Serie a la que pertenece",
    "series-TRD": "Series - TRD",
    "seriesCode": "Código serie",
    "seriesItBelongsTo": "Serie a la que pertenece",
    "seriesStoredSuccessfully": "Serie almacenada correctamente",
    "serverCommunicationError": "Error de comunicación con el servidor",
    "serviceAndSupportModule": "Módulo de atención y servicio",
    "setAsTheCurrentVersion": "Establecer como versión actual",
    "setTheVersion#VersionName#AsTheCurrentDocumentRetentionTableVersion": "Establece la versión #Nombre versión# como la versión actual de tabla de retención documental ",
    "setVersion": "Establecer versión",
    "sheetNumber": "Número de planilla",
    "sheets": "Folios",
    "sheetsInShipment": "Planillas en envío",
    "shelf_Estante": "Estante",
    "shelf": "Entrepaño",
    "shiftTemplate": "Plantilla turno",
    "shipmentCanceled": "Envío cancelado",
    "shippingAssignment": "Asignación de envios",
    "shippingAssignmentCompletedSuccessfully": "Asignación de envio completada correctamente",
    "shippingGuide": "Guia de envío",
    "shippingMethod": "Medio de envío",
    "shippingMethods": "Medios de envio",
    "shippingMethodSavedSuccessfully": "Medio de envío almacenado correctamente",
    "shippingZone": "Zona de envío",
    "showAll": "Mostrar todo",
    "showIndex": "Mostrar indice",
    "dataTablePaginationMessage": "Mostrando {{start}} al {{lastItem}} de {{totalRecords}}",
    "side": "Cara",
    "sign": "Firmar",
    "signatureConfiguration": "Configuración firma",
    "signatureConfigurationSavedSuccessfully": "Configuración de firma almacenada correctamente",
    "signatureType": "Tipo de firma",
    "signDocument": "Firmar documento",
    "simpleSeries": "Serie simple",
    "simulate": "Simular",
    "sites": "Sitios",
    "size": "Tamaño",
    "south": "Sur",
    "southeast": "Suroriente",
    "specificTerms": "Términos específicos",
    "specifyTheCustomComponentOfProcesoXToBeRenderedWhenSelectingTheProcedure": "Especifica el componente personalizado de ProcesoX que se va a renderizar al seleccionar el trámite",
    "specifyTheDataAccessFunction": "Especifica la función de acceso a datos",
    "specifyTheUserToAssignTheFirstTaskOfTheProcess": "Especifica el usuario al que se asigna la primera tarea del proceso",
    "start": "Inicio",
    "startDate": "Fecha inicial",
    "startDateOfRecordCreation": "Fecha inicio creación expediente",
    "startDocumentProcess": "Iniciar proceso documental",
    "status": "Estado",
    "sticker": "Sticker",
    "stopServiceAndClearConfiguration": "Detener servicio y borrar configuración",
    "stopServices": "Detener servicios",
    "storage": "Almacenamiento",
    "storageRecord": "Expediente de almacenamiento",
    "structure": "Estructura",
    "subfondo": "Subfondo",
    "subfund": "Subfondo",
    "subject": "Asunto",
    "subscription": "Suscripción",
    "subscriptions": "Suscripciones",
    "subscriptionUpdated": "Suscripción actualizada",
    "subseccion": "Subsección",
    "subsection": "Subsección",
    "subserie": "Subserie",
    "subseriesCode": "Código subserie",
    "subseriesStoredSuccessfully": "Subserie almacenada correctamente",
    "surveys": "Encuestas",
    "synchronizeDataAAD": "Sincronizar datos AAD",
    "systemFile": "Archivo sistema",
    "tableUpdatedSuccessfully": "Tabla actualizada correctamente",
    "tacitWaiver": "Desistimiento tácito",
    "targetVariable": "Variable destino",
    "tasks": "Tareas",
    "taskType": "Tipo de tarea",
    "taskTypes": "Tipos de tarea",
    "template": "Plantilla",
    "templateGenerated": "Plantilla generada",
    "templates": "Plantillas",
    "terminologicalBank": "Banco Terminológico",
    "terminologyBankStoredSuccessfully": "Banco Terminológico almacenado correctamente",
    "text": "Texto",
    "theApprovalRequestHasBeenCompletedSuccessfully": "La solicitud de visto bueno se ha completado corretamente",
    "theApprovalRequestHasBeenRejectedSuccessfully": "La solicitud de visto bueno se ha rechazado corretamente",
    "theCityWasSavedSuccessfully": "La ciudad se guardo correctamente",
    "theCountryWasSavedSuccessfully": "El país se guardo correctamente",
    "theCreationOfTheIncomingFileHasNotBeenCompletedYet.AreYouSureYouWantToDeleteIt": "¿La creación del radicado de entrada aún no se ha completado. ¿Está seguro que desea eliminarlo?",
    "theCurrentIncomingFileHasNoLinkedFiles": "El radicado de entrada actual no tiene radicados vinculados ",
    "theCurrentUserDoesNotHavePermissionToViewThePackagingRequest": "El usuario actual no tiene permiso para visualizar la solicitud de empaquetamiento",
    "theDepartmentWasSavedSuccessfully": "El departamento se guardo correctamente",
    "theDocumentCannotBeDeletedBecauseItIsLinkedToAnotherRecord": "No se puede eliminar el documento debido a que está enlazado a otro Expediente",
    "theDocumentRetentionTableVersionIsInactive": "La versión de tabla de retención documental está inactiva",
    "theDocumentRetentionTableVersionWasNotFound.Version": "#numero de versión#",
    "theFollowingDataOfTheReturnReasonWereUpdated": "Reagendar envío de 'No' a 'Si'",
    "theFollowingPrerequisitesAreRequired": "Se necesitan los siguientes requisitos previos",
    "theIdTablaRetencionDocumentalParameterDoesNotHaveAValidValue(0)": "El parámetro idTablaRetencionDocumental no tiene un valor valido (0)",
    "theIncomingFilesCannotBeLinkedBecauseTheMainIncomingFileIsNotInThe'InProgress'State": "No se puede enlazar los radicados debido a que el radicado principal no se encuentra en estado 'En Trámite'",
    "theIncomingRecordHasBeenLinkedToTheInitialRequestNumber#RecordNumber#WithTheFollowingComment": "",
    "theInternalCommunicationCannotBeReassignedBecauseTheDestinationUserIsTheSameAsTheCurrentUser": "No se puede reasignar el comunicado interno debido a que el usuario destino es igual al usuario actual",
    "theOutgoingFileHasNoAssociatedApprovalRequests": "El radicado de salida no tiene solicitudes de visto bueno asociadas",
    "theOutgoingFileHasNoAssociatedInformationRequests": "El radicado de salida no tiene solicitudes de información asociadas",
    "thePermission'ReadAllDocumentTypes'WasGrantedToSection#SECTION#__": "El usuario #USUARIO# ha consultado el expediente",
    "thePermission'ReadAllDocumentTypes'WasGrantedToSection#SECTION#": "Se concedió el permiso 'Leer todos los tipos documentales' a la sección #SECCION#",
    "thePermissionFromSection#SECTION#WasRemovedFromTheRecord": "Se eliminó el permiso de la sección #SECCION# sobre el expediente",
    "thePersonIdentifiesAs": "La persona se identifica como",
    "theProfileWasSavedSuccessfully": "El perfil se guardo correctamente",
    "theRecordCannotBeDeletedBecauseItHasAssociatedRecords": "No se puede eliminar el expediente porque tiene expedientes asociados",
    "theRecordIsClosed,AndTheCreation,Editing,OrDeletionOfDocumentsIsNotAllowed": "El expediente está cerrado y no se permite la creación, edición o eliminación de documentos",
    "theRecordNameWasChangedSuccessfully": "Se cambio el nombre al expediente correctamente",
    "theRecordWasClosed.Observations": "",
    "theRecordWasIncludedInFileNo": "Se incluyó el radicado en el expediente No.",
    "theRecordWasLocked.Observations": ",",
    "theRecordWasRenamedFrom#RECORDNAME#To#RECORDNAME#": "Se renombró el expediente de #NOMBRE EXPEDIENTE# a #NOMBRE EXPEDIENTE#",
    "theRequestToMoveTheDocumentsWasCreatedSuccessfully": "La solicitud de movimiento de los documentos se creó correctamente",
    "theResponsibleOfTheRecordWasChangedFrom#USER#To#USER#.Observations": "",
    "theReturnReasonCannotBeDeletedAsItHasDependencies": "No se puede eliminar el motivo de devolución debido a que tiene dependencias",
    "theReturnReasonWithTheName'reasonName'WasCreated": "Se creó el motivo de devolución con Nombre 'nombre del motivo'",
    "theSecurityLevelHasBeenUpdatedTo'Classified": "Se actualizó el nivel de seguridad a 'Clasificado'",
    "theSecurityLevelHasBeenUpdatedTo'Public": "Se actualizó el nivel de seguridad a 'Publico",
    "theSecurityOfTheRecordWasUpdatedToNotInheritPermissionsFromTheRetentionTable": "Se actualizó la seguridad del expediente para no heredar permisos de la tabla de retención documental",
    "theSigningUserCannotBeInTheMainRecipientsList": "El usuario firmante no puede estar en la lista de destinatarios principales",
    "theTimeZoneIsMandatory": "La zona horaria es obligatoria",
    "theURLForTheTramitexIncomingMailReportHasNotBeenConfigured.PleaseContactTheSystemAdministratorToUpdateTheSubscriptionParameters": "No se ha parámetrizado la url del reporte de radicados de entrada Tramitex. Por favor contacte al administrador del sistema para que se actualice los parámetros de la suscripción",
    "theUserUSERNAMEIsAlreadyIncludedAmongTheRecipientsOfTheInternalCommunication": "El usuario NOMBREDELUSUARIO ya se encuentra incluido entre los destinatarios del comunicado interno",
    "theUserWasSavedSuccessfully": "El usuario se guardó correctamente",
    "theUserWasSuccessfullyAssociatedWithTheSection": "El usuario se asoció correctamente a la sección",
    "thirdCall": "Tercer llamado",
    "thisCommunicationIsAssociatedAsAResponseToCommunication#communicationnumber#": "Este comunicado se asocia como respuesta al comunicado #decomunicado",
    "thisIncomingFileIsAssociatedAsAResponseToIncomingFile#incomingnumber#": "Este radicado se asocia como respuesta al radicado # de radicado #",
    "time": "Tiempo",
    "timeUnit": "Unidad de tiempo",
    "timeZone": "Zona Horaria",
    "tipoRadicado": "Tipo de radicado",
    "title": "Titulo",
    "to": "Hasta",
    "toBack": "Volver",
    "top-levelClassification": "Clasificación nivel superior",
    "topic": "Tema",
    "topicScope": "Alcance tema",
    "toUpdate": "Actualizar",
    "tramite": "Trámite",
    "transferDate": "Fecha de Transferencia",
    "transfers": "Transferencias",
    "transferSchedule": "Cronograma Transferencia",
    "transmissionDate": "Fecha de transmisión",
    "tRDCode": "Código TRD",
    "tRDDocumentTypes": "Tipos documentales TRD",
    "tRDSubseries": "Subseries TRD",
    "tRDVersion": "Versión TRD",
    "type": "Tipo",
    "typeOfIdentification": "Tipo de identificación",
    "typeOfShipment": "Tipo de envío",
    "uniqueDocumentInventoryFormat(FUID)": "Formato unico de inventario documental (FUID)",
    "unlockRecord": "Desbloquear expediente",
    "update": "Actualización",
    "updateContactType": "Actualizar tipo de contacto",
    "updateDocumentRetentionTable": "Actualización tabla de retención documental",
    "updateFromExcel": "Actualizar desde excel",
    "updateSection": "Actualizar sección",
    "updateTheRecord'sSecuritySoItDoesn'tInheritPermissionsFromTheRetentionTable": "Actualiza la seguridad del expediente para que no herede permisos de la tabla de retención documental ",
    "uploadDate": "Fecha de carga",
    "uploadDocument": "Cargar documento",
    "uploadScannedDocuments": "Cargar documentos digitalizados",
    "uploadVoucher": "Cargar comprobante",
    "uRI": "URI",
    "user": "Usuario",
    "user#USER#HasViewedTheRecord": "El usuario #USUARIO# ha consultado el expediente",
    "userInterface": "Interfaz de usuario",
    "userPreferences": "Preferencias de usuario",
    "users": "Usuarios",
    "userSuccessfullyDeleted": "Usuario eliminado correctamente.",
    "userTask-ProcessX": "Tarea de usuario - ProcesoX",
    "validatePostponingTheFileTransfer": "Validar posponer la transferencia de expedientes",
    value: "Valor",
    variable: "Variable",
    variableName: "Nombre variable",
    variables: "Variables",
    version: "Versión",
    versionCreatedSuccessfully: "Versión creada correctamente",
    versionGeneratedOn: "Versión generada en",
    versions: "Versiones",
    versionSuccessfullySetAsCurrent: "Versión establecida como actual correctamente",
    versionTRD: "Versión TRD",
    versionTVD: "Versión TVD",
    video: "Video",
    view: "Ver",
    viewAll: "Ver todo",
    viewDocument: "Ver documento",
    viewElectronicHeadquartersButton: "Ver botón sede electrónica",
    viewFile: "Ver expediente",
    viewRecord: "Ver radicado",
    visible: "Visible",
    voBoRequestSentSuccessfully: "Solicitud de visto bueno enviada con éxito",
    voucherUploadedSuccessfully: "Comprobante cargado con éxito",
    wasTheServiceProvidedInATimelyManner: "¿El servicio se prestó de manera oportuna?",
    webhooks: "WebHooks",
    webRegistration: "Registro web",
    west: "Occidente",
    window: "Ventanilla",
    withoutVoucher: "Sin comprobante",
    word: "Palabra",
    year: "Año",
    yes: "Si",
    youMustSelectAMetadata: "Debe seleccionar un metadato",
    youMustSelectSomeTypeOfNotificationEitherByEmailOrAtTheRegisteredAddress: "Debe seleccionar algún tipo de notificación, ya sea por correo electrónico o en la dirección registrada",
    youResideIn: "Usted reside en",
    zone: "Zona",
    zoneSavedSuccessfully: "Zona almacenada correctamente",
    darkMode: "Modo oscuro",
    english: "Inglés",
    itemUpdatedSuccessfully: "Elemento actualizado correctamente",
    language: "Idioma",
    languagePreference: "Preferencia de idioma",
    logIn: "Iniciar sesión",
    previewFeatures: "Características de vista previa",
    secondaryTransfer: "Transferencia secundaria",
    secondCall: "Segundo llamado",
    section: "Sección",
    sectionCode: "Código sección",
    sectionCreated: "Se creó sección",
    sectionResponsibleForProcessingTheIncomingCorrespondence: "Sección responsable de tramitar el radicado de entrada",
    sections: "Secciones",
    sectionStoredSuccessfully: "Sección almacenada correctamente",
    sectionUpdated: "Sección actualizada",
    sector: "Sector",
    secureMethod: "Medio seguro",
    security: "Seguridad",
    securityLevel: "Nivel de seguridad",
    securityLevelUpdatedToReserved: "Se actualizó el nivel de seguridad a 'Reservado'",
    securityUpdate: "Actualización de seguridad",
    securityUpdatedSuccessfully: "Seguridad actualizada correctamente",
    select: "Seleccione",
    selectADate: "Seleccione una fecha",
    selectADocumentType: "Seleccione un tipo documental",
    selectAnItem: "Seleccione un elemento",
    selectContact: "Seleccionar contacto",
    selectDocuments: "Seleccionar documentos",
    selectFiles: "Seleccionar archivos",
    sendingDocuments: "Envío de documentos",
    sendSurveyDevice: "Enviar encuesta a Dispositivo",
    sendSurveyEmail: "Enviar encuesta a Email",
    sigla: "Sigla",
    spanish: "Español",
    startScreenCapture: "Iniciar captura de pantalla",
    tutorials: "Tutoriales",
    userPreferencesSavedSuccessfully: "Preferencias de usuario guardadas",
};
